<template>
  <div
    @mouseover="hover = true"
    @mouseleave="hover = false"
    :class="editorClasses"
    group="rowcontent"
  >
    <EditorOptions
      parent="row"
      v-show="hover && ! childHover & ! previewMode"
      :options="menuOptions"
    />
    <div :class="elementContainerClasses">
      <div
        :class="elementClasses"
        :style="elementStyles"
      >
        <draggable
          class="wf-flex wf-w-full wf-flex-row wf-flex-wrap"
          v-model="columns"
          group="columns"
          handle=".column-handle"
        >
          <EditorColumn
            @mouseover="childHover = true"
            @mouseleave="childHover = false"
            v-for="column in columns"
            :key="column.id"
          />
        </draggable>
      </div>
    </div>
  </div>
</template>

<script>
  import EditorColumn from  './EditorColumn'
  import { ConstantsParser } from '../ConstantsParser'
  import EditorElement from '../contracts/EditorElement'
  export default EditorElement.extend({
    props: {
      componentRow: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    components: {EditorColumn},
    computed: {
      elementContainerClasses() {
        return (new ConstantsParser(this.containerClasses, this.device)).parse()
      },
      elementClasses() {
        if (this.previewMode) {
          return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(this.classes, this.device)).parse()]
        }
        let displayClasses = []
        let classes = Object.keys(this.classes).reduce((carry, device) => {
          let deviceDisplayClass = this.classes[device].find(deviceClass => deviceClass.property == 'Display')
          if (deviceDisplayClass) {
            let opacity = 'wf-opacity-100'
            let prefix = ''
            if (device === 'tablet') {
              prefix = 'sm:'
            }
            if (device === 'desktop') {
              prefix = 'lg:'
            }
            if (deviceDisplayClass.value == 'NONE') {
              opacity = 'wf-opacity-50'
            }
            displayClasses.push(`${prefix}${opacity}`)
          }
          let deviceObject = {}
          let deviceClasses = this.classes[device].filter(deviceClass => deviceClass.property != 'Display')
          this.$set(deviceObject, device, deviceClasses)
          return {...carry, ...deviceObject}
        }, {})
        return [...this.constantClasses, ...this.customClasses, ...(new ConstantsParser(classes, this.device)).parse(), ...displayClasses]
      },
      module() {
        return 'rowModule'
      },
      
      parent() {
        return this.$parent.$parent
      },
      
      family() {
        return 'rows'
      },

      containerClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'containerClasses')
      },

      classes() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'classes')
      },
      properties() {
        return this.$store.getters[`${this.module}/properties`](this.element)
      },
      
      customClasses() {
        return this.$store.getters[`${this.module}/classes`](this.element, 'customClasses')
      },

      rowIndex() {
        let element = {section: this.sectionIndex}
        return this.$store.getters[`${this.module}/index`](element, this.id)
      },

      sectionIndex() {
        return this.parent.sectionIndex
      },

      styles() {
        return this.$store.getters[`${this.module}/styles`](this.element, 'styles')
      },

      columns: {
        get() {
          return this.$store.getters['columnModule/elements'](this.element)
        },
        set(value) {
          this.$store.dispatch('columnModule/updateOrder', {
            section: this.sectionIndex,
            row: this.rowIndex,
            value
          })
        },
      },
    },
  })
</script>